import React from "react";
import { connect } from "react-redux";
import TabContainer from "containers/RequestTabContainer";
import { initialTabs } from "helpers/WizardHelper";
// import { lastWizardStep, saveWizardStep } from 'actions/wizard';

const InitialTabs = ({ wizard, history }) => {
  const { isSubmitted, isSaved, step } = wizard;
  if (isSubmitted || isSaved) return null;
  return (
    <TabContainer
      show={true}
      component={initialTabs[step]}
      isEditable={true}
      canSubmit={true}
      history={history}
    />
  );
};

function mapStateToProps({ wizard }) {
  return { wizard };
}

export default connect(mapStateToProps)(InitialTabs);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/InitialTabs.js